import type { ReactNode } from 'react';
import { cn } from './cn';
import { Icon } from './icon';

/**
 * Card section that collapses on a click on its title (FR-PRJ-016). Actions in the header do
 * not toggle it. Open/closed state is owned by the caller (persisted per section there).
 */
export function CollapsibleSection({
  id,
  title,
  open,
  onToggle,
  actions,
  children,
}: {
  id: string;
  title: string;
  open: boolean;
  onToggle: () => void;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const panelId = `section-${id}`;
  return (
    <section
      className="rounded-card border border-border bg-surface shadow-sm"
      aria-labelledby={`${panelId}-title`}
    >
      <header className="flex items-center justify-between gap-3 px-5 py-3">
        <button
          type="button"
          id={`${panelId}-title`}
          aria-expanded={open}
          aria-controls={panelId}
          onClick={onToggle}
          className="flex flex-1 items-center gap-2 text-left text-base font-semibold"
        >
          <Icon name="chevron-down" className={cn('size-4 transition-transform', !open && '-rotate-90')} />
          {title}
        </button>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </header>
      {open && (
        <div id={panelId} className="border-t border-border p-5">
          {children}
        </div>
      )}
    </section>
  );
}
